module.exports = __webpack_public_path__ + "static/media/firework_explosion.9c97a5a6.png";